
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RequestHeaders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"abTest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shopId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xUserToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xLangTag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gatewayUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetsPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryDsn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryEnvironment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentryTracingRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ProductSsrData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pathname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":367}};
    doc.loc.source = {"body":"query getDefaultData {\n  RequestHeaders {\n    __typename\n    role\n    userId\n    userEmail\n    userName\n    abTest\n    shopId\n    xUserToken\n    xLangTag\n    gatewayUrl\n    assetsPath\n    sentryDsn\n    sentryEnvironment\n    sentryTracingRate\n    originUrl\n    mounts\n    features\n  }\n  ProductSsrData {\n    __typename\n    id\n    pathname\n    productId\n    type\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getDefaultData"] = oneQuery(doc, "getDefaultData");
        

doc.documentId = "ddfde0f1524bc0327fa8ce86fda1c3c89505228aa37459d694d781afd5b13799"